import React from 'react';
import { isNum, clamp } from './chartUtils';
import './charts.css';

/**
 * Labelled horizontal bars. rows: [{key,label,value,max?,layerValue?,valueText?,title?}].
 * `layerValue` draws a second, stronger bar over the first (e.g. implemented over in-scope coverage); both
 * are measured against the same `max`: the row's own `max`, else the prop, else the largest value.
 */
const BarList = ({ rows, max, label, baseName, layerName, testId }) => {
  const list = (rows || []).filter((r) => r && isNum(r.value));
  if (!list.length) return <div className="pl-barlist__empty" data-testid={testId}>No data to chart yet.</div>;
  const globalMax = isNum(max) ? max : Math.max(...list.map((r) => r.value), 1);
  const layered = list.some((r) => isNum(r.layerValue));
  return (
    <div data-testid={testId}>
      <ul className="pl-barlist" aria-label={label}>
        {list.map((r) => {
          const m = isNum(r.max) && r.max > 0 ? r.max : globalMax;
          const w = clamp((r.value / m) * 100, 0, 100);
          const lw = isNum(r.layerValue) ? clamp((r.layerValue / m) * 100, 0, 100) : null;
          const text = r.valueText || String(r.value);
          return (
            <li key={r.key} className="pl-barlist__row" title={r.title}>
              <span className="pl-barlist__label">{r.label}</span>
              <span className="pl-barlist__track" role="img" aria-label={`${r.label}: ${text}`}>
                <span className="pl-barlist__fill" style={{ width: `${w}%`, background: layered ? 'var(--chart-3)' : 'var(--chart-1)', opacity: layered ? 0.55 : 1 }} />
                {lw != null && <span className="pl-barlist__fill" style={{ width: `${lw}%`, background: 'var(--chart-1)' }} />}
              </span>
              <span className="pl-barlist__value">{text}</span>
            </li>
          );
        })}
      </ul>
      {layered && baseName && layerName ? (
        <ul className="pl-chart-legend">
          <li><span className="pl-chart-swatch" style={{ background: 'var(--chart-3)', opacity: 0.55 }} />{baseName}</li>
          <li><span className="pl-chart-swatch" style={{ background: 'var(--chart-1)' }} />{layerName}</li>
        </ul>
      ) : null}
    </div>
  );
};

export default BarList;
